import FieldsCollection from "../../fields3/collection/base/fields-collection";
import FieldMoment from "../../fields3/generic/datetime/moment/moment";
import {EntityType} from "../../gd/const/item";
import {FieldType} from "../../fields3/field-type";
import FieldTask from "../../fields3/generic/task/task";
import FieldReminder from "../../fields3/generic/reminder/reminder";
import FieldString from "../../fields3/generic/string/string";
import FieldMeeting from "../../fields3/generic/meeting/meeting";
import FieldEvent from "../../fields3/generic/event/event";


const baseConfig = [

    {
        fieldId : 'id',
        type    : FieldType.STRING,
        label   : 'ID'
    },
    {
        fieldId: 'frequency',
        type: FieldType.STRING
    },
    {
        fieldId     : 'cronNextMoment',
        type        : FieldType.MOMENT,
        label       : 'Next Run'
    },



    {
        fieldId     : 'task',
        type        : FieldType.TASK
    },
    {
        fieldId     : 'meeting',
        type        : FieldType.MEETING
    },
    {
        fieldId     : 'event',
        type        : FieldType.EVENT
    },
    {
        fieldId     : 'reminder',
        type        : FieldType.REMINDER
    }
]

export default class RecurrenceFields extends FieldsCollection {


    // Quick access

    get id()                : FieldString { return this.get('id') as FieldString }
    get frequency()         : FieldString { return this.get('frequency') as FieldString}
    get cronNextMoment()    : FieldMoment { return this.get('cronNextMoment') as FieldMoment }
    get task()              : FieldTask { return this.get('task') as FieldTask}
    get reminder()          : FieldReminder { return this.get('reminder') as FieldReminder }
    get meeting()           : FieldMeeting { return this.get('meeting') as FieldMeeting }
    get event()             : FieldEvent { return this.get('event') as FieldEvent }


    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.RECURRENCE);

    }





}